export enum Links {
	Twitter = "https://twitter.com/StarLusts_JP",
	Download = "https://games.dmm.co.jp/detail/starlusts",
	DMMPlayerUri = "dmmgameplayer://starlust/cl/adult",
	DMMInstallerWinUrl = "https://accounts.dmm.com/service/login/password?channel=games&path=https%3A%2F%2Fpersonal.games.dmm.com%2Fprofile%2Fregist%2Fskip%3Fback_url%3Dhttps%253A%252F%252Fsite-gameplayer.dmm.com%252Fgameplayer%252Fgame%252Finstaller%252Fwin%252Fx86%252Fstarlust%252Fcl%252Fadult",
	Home = "/#billboard",
	WorldOverview = "/#world-overview",
	Feature = "/#feature",
	Announcements = "/announcements",
	Characters = "/characters",
	Contact = "https://support.pinkcore.com",
	Terms = "https://reg-sl-dm.skycreation.website/service_ja.html",
	Policy = "https://reg-sl-dm.skycreation.website/privacy_ja.html",
	Announce ="https://reg-sl-dm.skycreation.website/commerce_ja.html",
}
